import React, { useContext, useEffect, useState } from "react";

import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import WarningIcon from "@material-ui/icons/Warning";

import api from "../../services/api";
import { AuthContext } from "../../context/Auth/AuthContext";
import SubscriptionModal from "../SubscriptionModal";

const DISMISSED_KEY = "invoiceDueReminderDismissed";

const InvoiceDueReminder = () => {
  const { user } = useContext(AuthContext);
  const [dueInvoice, setDueInvoice] = useState(null);
  const [reminderOpen, setReminderOpen] = useState(false);
  const [paymentOpen, setPaymentOpen] = useState(false);

  useEffect(() => {
    if (!user?.id) return;

    const checkDueInvoices = async () => {
      try {
        const { data } = await api.get("/invoices/all");
        const invoices = Array.isArray(data) ? data : [];

        const hoje = new Date();
        hoje.setHours(0, 0, 0, 0);

        const vencida = invoices.find((invoice) => {
          if (invoice.status === "paid") return false;
          const vencimento = new Date(invoice.dueDate);
          vencimento.setHours(0, 0, 0, 0);
          return vencimento <= hoje;
        });

        if (!vencida) return;

        const dismissedId = sessionStorage.getItem(DISMISSED_KEY);
        if (String(dismissedId) === String(vencida.id)) return;

        setDueInvoice(vencida);
        setReminderOpen(true);
      } catch (_) {
        // silencioso: não deve atrapalhar o login por causa disso
      }
    };

    checkDueInvoices();
  }, [user?.id]);

  const handleDismiss = () => {
    if (dueInvoice) {
      sessionStorage.setItem(DISMISSED_KEY, String(dueInvoice.id));
    }
    setReminderOpen(false);
  };

  const handlePayNow = () => {
    setReminderOpen(false);
    setPaymentOpen(true);
  };

  if (!dueInvoice) return null;

  const valorFormatado = Number(dueInvoice.value || 0).toLocaleString(
    "pt-BR",
    { style: "currency", currency: "BRL" }
  );
  const vencimentoFormatado = new Date(dueInvoice.dueDate).toLocaleDateString(
    "pt-BR"
  );

  return (
    <>
      <Dialog open={reminderOpen} onClose={handleDismiss} maxWidth="xs" fullWidth>
        <DialogTitle style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <WarningIcon color="error" />
          Fatura em aberto
        </DialogTitle>
        <DialogContent>
          <Typography variant="body1" gutterBottom>
            Você tem uma fatura no valor de <b>{valorFormatado}</b> com
            vencimento em <b>{vencimentoFormatado}</b>.
          </Typography>
          <Typography variant="body2" color="textSecondary">
            Efetue o pagamento para evitar transtornos com o acesso ao
            sistema.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDismiss}>Depois</Button>
          <Button variant="contained" color="primary" onClick={handlePayNow}>
            Pagar agora
          </Button>
        </DialogActions>
      </Dialog>

      <SubscriptionModal
        open={paymentOpen}
        onClose={() => setPaymentOpen(false)}
        Invoice={dueInvoice}
      />
    </>
  );
};

export default InvoiceDueReminder;
